// SPDX-License-Identifier: LicenseRef-Proprietary
// Copyright (c) 2026 Invariant Holdings LLC

import React from "react";
import { colorWithAlpha } from "@csk/demo-ui";
import { panelTokens } from "@csk/demo-ui";

export function ManuscriptLink({
  path,
  children,
}: {
  readonly path: string;
  readonly children: React.ReactNode;
}): React.JSX.Element {
  return (
    <a
      href={`https://github.com/invariantholdings/categorical-safety-kernel/tree/main/${path}`}
      target="_blank"
      rel="noreferrer noopener"
      className="border-b border-dashed text-[var(--ilg-accent)] no-underline"
      style={{ borderBottomColor: colorWithAlpha(panelTokens.accent, "66") }}
    >
      {children}
    </a>
  );
}
